export default "__VITE_ASSET__bb62c27c__"